export const actionTypes = {
  SET: 'TAPS.RESPONSE.SET',
  RESET: 'TAPS.RESPONSE.RESET',
};

export function set(value) {
  return {
    type: actionTypes.SET,
    payload: value,
  };
}

export function reset() {
  return {
    type: actionTypes.RESET,
  };
}
